import CurrentPlanButton from 'pricing-pages-lib/js/buttons/CurrentPlanButton';
import { getTrellisButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import SignupButton from '../../components/common/SignupButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const FreeToolsPurchaseMotion = ({
  trackingSource,
  sourceId = 'pricing-hero',
  productLine = 'crm',
  isInApp = false
}) => {
  const trellisCtaVariantProps = getTrellisButtonVariantProps({
    variant: 'block'
  });
  return isInApp ? /*#__PURE__*/_jsx(CurrentPlanButton, {
    visible: trellisCtaVariantProps.visible
  }) : /*#__PURE__*/_jsx(SignupButton, {
    sourceId: sourceId,
    productLine: productLine,
    use: "primary",
    trackingSource: trackingSource
  });
};